import { render } from "./ImageGalleryDesktopSlider.vue?vue&type=template&id=83f0e318&ts=true"
import script from "./ImageGalleryDesktopSlider.vue?vue&type=script&lang=ts"
export * from "./ImageGalleryDesktopSlider.vue?vue&type=script&lang=ts"

import "./ImageGalleryDesktopSlider.vue?vue&type=style&index=0&id=83f0e318&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__